import { lazy } from 'react'

/**
 * Use named imports with React Lazy loading of a component.
 * @param loader Import a component.
 * @returns
 */
export const lazyImport = <T extends object>(loader: (x?: string) => Promise<T>) =>
  new Proxy({} as unknown as T, {
    get: (_target, componentName: string | symbol) => {
      if (typeof componentName === 'string') {
        return lazy(() =>
          loader(componentName).then(x => ({
            default: x[componentName] as any as React.ComponentType<any>,
          })),
        )
      }
    },
  })
